import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const rolePermissionAddApi = createAsyncThunk(
    'auth/rolePermissions/add',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(apiRoutes.adminAction("roles_permissions/roles", 1), data)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const rolePermissionAddSlice = createSlice({
    name: 'rolePermission Add',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(rolePermissionAddApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(rolePermissionAddApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(rolePermissionAddApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const rolePermissionAddReducer = rolePermissionAddSlice.reducer